import {Pipe, PipeTransform} from '@angular/core';
import {LocalizationService} from '../services/localization.service';
import {Observable, of} from 'rxjs';
import {SupportedAgeEnum, VoiceBotAge, voiceBotAges} from '../models/voice-bot.model';

@Pipe({
    name: 'i18nVoiceBotAge',
    standalone: false
})

export class I18nVoiceBotAgePipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) {
    }

    transform(age: string): Observable<string> {
        const voiceBotAge = voiceBotAges?.find((voiceBotAge: VoiceBotAge) => {
            return voiceBotAge.shortName === age as SupportedAgeEnum;
        });

        if (!!voiceBotAge?.i18nKey) {
            return this.localizationService.getTranslationByKeyAsync(voiceBotAge.i18nKey);
        } else {
            return of(age);
        }
    }
}
